import { Loading } from "element-ui";
import { fun_PostAction, fun_GetAction, fun_UploadImg } from "@/api/index";
import { fun_GetKeys } from "@/utils/validate";
import CaLock from "@/components/common/calock";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import TendererNoticeChoose from "../components/tendererNoticeChoose/index.vue";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 流程状态
      stepsActive: 0,
      // 流程数据
      stepsList: [
        {
          name: "项目选择",
          isSave: false, // 是否保存
          isActive: true, // 是否可点击
          icon: true // 是否有必填项
        },
        {
          name: "参加开标会投标单位名单",
          isSave: false,
          isActive: true
        },
        {
          name: "招标过程综述",
          isSave: false,
          isActive: true
        },
        {
          name: "情况一览",
          isSave: false,
          isActive: true
        },
        {
          name: "其他信息",
          isSave: false,
          isActive: true
        }
      ],
      // 默认展开全部面板
      activeName: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14"
      ],
      // 全局加载
      fullLoading: null,
      // 主键
      id: null,
      // 操作标识
      controllerFlag: null,
      // 甲方确认标志
      isTenderSignature: null,
      // 招标投标情况
      tendererSituation: {
        prjName: null, // 招标项目名称
        constructionNo: null, // 报建编号
        constructionPrjName: null, // 报建项目名称
        noticeId: null, // 公告编号
        registrationId: null, // 招标登记编号
        prjAddress: null, // 工程地址
        tenderName: null, // 招标人
        tenderCorpId: null, // 招标人编号
        agencyCorpName: null, // 招标代理名称
        agencyCorpId: null, // 招标代理编号
        tenderLinkMan: null, // 招标联系人
        tenderLinkPhone: null, // 联系电话
        noteNumber: null, // 立项批准文号
        allInvest: null, // 本次招标金额（万元）
        tenderTypeName: null, // 招标方式名称
        tenderTypeNum: null, // 招标方式
        prequalificationTypeName: null, // 资格审查方式名称
        prequalificationType: null, // 资格审查方式
        evaluationMethod: null, // 评标办法
        evaluationMethodName: null, // 评标办法名称
        sectionQuantity: null, // 标段划分情况
        controlledPriceCorpName: null, // 招标控制价编制单位
        controlledPriceCorpLevelName: null, // 资质等级名称
        controlledPriceCorpLevel: null, // 资质等级
        agencyCorpLevelName: null, // 招标代理机构资质等级名称
        agencyCorpLevel: null, // 招标代理机构资质等级
        constructionSituation: null, // 报建登记
        agencyCorpRecords: null, // 招标代理合同备案
        tendererRemarks: null, // 备注
        tendererRegistration: null, // 招标登记
        tendererDocumentReview: null, // 招标文件编制核验
        tendererNotice: null, // 招标公告（或投标邀请书）
        bidderQualification: null, // 投标人资格审查
        tenderDocumentIssued: null, // 招标文件发出
        siteSurveyQuestions: null, // 现场踏勘察和答疑
        tenderControlPrice: null, // 招标控制价
        judgesNumber: null, // 评委人数
        tendererJudgesNumber: null, // 招标人评委
        socialJudgesNumber: null, // 社会评委
        tendereringRemarks: null, // 备注
        opentingSituation: null, // 开标情况
        bidSituation: null, // 评标、定标情况
        publicitySuccessful: null, // 中标公示
        bidWinNotice: null, // 中标通知书
        opentingRemarks: null, // 备注
        processDescription: null, // 过程描述
        isAudit: null, // 是否核验
        tenderOpinion: null, // 招标人意见
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
        state: null, // 状态
        regulators: null // 招标管理部门
      },
      // 错误验证
      error: {
        prjName: null
      },
      // 评标概述
      evaluationReportList: [],
      // 房屋建筑工程规模基础数据
      winningColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          minWidth: "300"
        },
        {
          label: "标段号",
          prop: "section",
          minWidth: "80"
        },
        {
          label: "建筑面积（平米）",
          prop: "structureArea",
          minWidth: "200"
        },
        {
          label: "结构层次",
          prop: "highFloor",
          minWidth: "200"
        },
        {
          label: "地上层次（层）",
          prop: "upFloor",
          minWidth: "200"
        },
        {
          label: "地下层次（层）",
          prop: "underFloor",
          minWidth: "200"
        },
        {
          label: "建设规模",
          slotName: "prjSize",
          minWidth: "100"
        },
        {
          label: "招标范围",
          slotName: "tenderContentDescription",
          minWidth: "100"
        },
        {
          label: "备注（注明单体工程名称和栋号）",
          slotName: "remarksMonomer",
          minWidth: "300"
        }
      ],
      // 房屋建筑工程规模表数据
      winningList: [],
      // 招标机构组成人员基础数据
      orgColumns: [
        {
          label: "姓名",
          prop: "name"
        },
        {
          label: "工作单位",
          prop: "corpName"
        },
        {
          label: "职务",
          prop: "duty"
        },
        {
          label: "工作职责",
          prop: "tendererMark"
        }
      ],
      // 招标机构组成人员表数据
      orgList: [],
      // 默认关闭遮罩
      loading: false,
      // 表头按钮
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "circle-plus-outline"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 参加开标会投标单位绑定数据
      formObj: {
        // 表格数据
        tableData: []
      },
      // 勾选的数组
      multipleSelection: [],
      // 参加开标会投标单位数据验证规则
      rule: {
        name: [
          {
            required: true,
            message: "该项不能为空",
            trigger: "blur"
          }
        ],
        corpName: [
          {
            required: true,
            message: "该项不能为空",
            trigger: "blur"
          }
        ]
      },
      // 招标控制价列表数据
      tenderFormObj: {
        priList: []
      },
      // 招标控制价列表验证
      tenderRule: {
        deepFoundationFee: {},
        environmentalProtection: {},
        laborCost: {},
        structureArea: {},
        period: {},
        qualityRequirement: {},
        divisionQualification: {}
      },
      // 中标情况列表数据
      winningBidFormObj: {
        priiList: []
      },
      // 中标情况列表验证
      winningBidRule: {},
      // 招标公告异常列表数据
      noticList: [],
      // 招标信息异常列表数据
      proList: [],
      // 项目负责人解锁变更数据
      recordList: [],
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null // 判断当前时提交还是退还至招标代理
      },
      // 招标过程综述 事项宽度
      labelWdth: 150,
      // 招标过程综述 序号
      serialWdth: 80,
      // 弹窗状态
      dialogVisible: false,
      // 弹框名称
      dialogTitle: null,
      // 弹框主键
      dialogId: null,
      // 弹框内容
      dialogCount: null,
      // 弹框操作状态
      dialogControllerFlag: null,
      // 一览传递判断状态图片
      stateObj: {
        tenderSignedId: null,
        tenderSignedState: null,
        state: null
      }
    };
  },
  // 注册组件
  components: {
    CaLock,
    AuditHistoryRecord,
    TendererNoticeChoose
  },

  // 模板编译完成
  mounted() {
    // 主键
    this.id = this.$route.query.id;
    // 甲方确认标志
    this.isTenderSignature = this.$route.query.isTenderSignature;
    // 操作标识
    this.controllerFlag = this.$route.query.controllerFlag;
    // 详情
    if (this.controllerFlag === "details") {
      // 清空按钮
      this.btnList = [];
    }
    // 不是新增时
    if (this.controllerFlag !== "insert") {
      // 请求详情
      this.fun_Details();
    }
  },
  // 自定义方法
  methods: {
    /**
     * 请求详情
     * @author shuhua
     */
    fun_Details() {
      // 发起请求
      fun_GetAction("/tendererSituation/detail", {
        id: this.id,
        isTenderSignature: this.isTenderSignature
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断是否请求成功
        if (result) {
          // 主键
          this.id = data.tendererSituation.id;
          // 招标投标
          this.tendererSituation = data.tendererSituation;
          // 评标概述
          this.evaluationReportList = data.evaluationReportList;
          // 招标机构组成人员信息
          this.orgList = data.orgList;
          // 参与开标会投标单位名单
          this.formObj.tableData = data.joinList;
          // 招标控制价信息
          this.tenderFormObj.priList = data.priList;
          // 中标信息
          this.winningBidFormObj.priiList = data.priiList;
          // 房屋建筑工程规模
          this.winningList = data.winningList;
          // 招标公告异常信息
          this.noticList = data.noticList;
          // 招标信息异常
          this.proList = data.proList;
          // 遍历
          this.proList.map(e => {
            // 标段名称
            e.section = "第" + e.section + "标段";
          });
          // 项目负责人解锁变更信息
          this.recordList = data.recordList;
          // 资格预审成员列表
          this.fun_PrequalificationMemberList();
          // 设置甲方确认
          this.fun_GetTenderSignature(data);
          // 执行判断是否填写数据
          this.fun_GetInitializeStepsIsData();
        }
      });
    },
    /**
     * 监听滚动
     */
    fun_HandleScroll(e) {
      // 判断
      if (e.target.offsetTop < this.$refs.sticky.offsetTop) {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "0 0 8px 3px rgba(0, 0, 0, 0.06)";
      } else {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "none";
      }
    },
    /**
     * 初始化时处理流程判断表单是否填写内容
     */
    fun_GetInitializeStepsIsData() {
      // 声明需要判断的字段
      var arrKey = [
        "prjName",
        "constructionNo",
        "prjAddress",
        "tenderName",
        "agencyCorpName",
        "tenderLinkMan",
        "tenderLinkPhone",
        "noteNumber",
        "allInvest",
        "tenderTypeName"
      ];
      // 遍历
      for (var i in arrKey) {
        // 判断当前是否存在值
        if (this.tendererSituation[arrKey[i]]) {
          // 设置当前状态
          this.stepsList[0].isSave = true;
          // 跳出循环
          break;
        }
      }
      // 判断设置状态
      if (this.winningList && this.winningList.length > 0)
        this.stepsList[0].isSave = true;
      if (this.orgList && this.orgList.length > 0)
        this.stepsList[0].isSave = true;
      // 判断当前流程是否存在数据
      if (this.formObj.tableData && this.formObj.tableData.length > 0)
        this.stepsList[1].isSave = true;
      // 声明需要判断的字段
      arrKey = [
        "constructionSituation",
        "agencyCorpRecords",
        "tendererRemarks",
        "tendererRegistration",
        "tendererDocumentReview",
        "tendererNotice",
        "bidderQualification",
        "tenderDocumentIssued",
        "siteSurveyQuestions",
        "tenderControlPrice",
        "judgesNumber",
        "tendererJudgesNumber",
        "socialJudgesNumber",
        "tendereringRemarks",
        "opentingSituation",
        "bidSituation",
        "publicitySuccessful",
        "bidWinNotice",
        "opentingRemarks"
      ];
      // 遍历
      for (var i in arrKey) {
        // 判断当前是否存在值
        if (this.tendererSituation[arrKey[i]]) {
          // 设置当前状态
          this.stepsList[2].isSave = true;
          // 跳出循环
          break;
        }
      }
      // 判断设置状态
      if (this.evaluationReportList && this.evaluationReportList.length > 0)
        this.stepsList[2].isSave = true;
      // 判断当前流程是否存在数据
      if (
        this.tenderFormObj.priList.length > 0 ||
        this.winningBidFormObj.priiList.length > 0 ||
        this.noticList.length > 0 ||
        this.proList.length > 0
      ) {
        // 设置当前状态
        this.stepsList[3].isSave = true;
      }
      // 判断当前流程是否存在数据
      if (this.tendererSituation.processDescription)
        this.stepsList[4].isSave = true;
      if (this.recordList && this.recordList.length > 0)
        this.stepsList[4].isSave = true;
    },
    /**
     * 用于判断当前流程是否填写数据
     */
    fun_GetStepsIsData() {
      // 判断当前流程
      if (this.stepsActive === 0) {
        // 声明需要判断的字段
        var arrKey = [
          "prjName",
          "constructionNo",
          "prjAddress",
          "tenderName",
          "agencyCorpName",
          "tenderLinkMan",
          "tenderLinkPhone",
          "noteNumber",
          "allInvest",
          "tenderTypeName"
        ];
        // 遍历
        for (var i in arrKey) {
          // 判断当前是否存在值
          if (this.tendererSituation[arrKey[i]]) {
            // 设置当前状态
            this.stepsList[this.stepsActive].isSave = true;
            // 跳出循环
            break;
          }
        }
        // 判断设置状态
        if (this.winningList && this.winningList.length > 0)
          this.stepsList[this.stepsActive].isSave = true;
        if (this.orgList && this.orgList.length > 0)
          this.stepsList[this.stepsActive].isSave = true;
      } else if (this.stepsActive === 1) {
        // 判断当前流程是否存在数据
        if (this.formObj.tableData && this.formObj.tableData.length > 0) {
          // 设置当前状态
          this.stepsList[this.stepsActive].isSave = true;
        } else {
          // 设置当前状态
          this.stepsList[this.stepsActive].isSave = false;
        }
      } else if (this.stepsActive === 2) {
        // 声明需要判断的字段
        var arrKey = [
          "constructionSituation",
          "agencyCorpRecords",
          "tendererRemarks",
          "tendererRegistration",
          "tendererDocumentReview",
          "tendererNotice",
          "bidderQualification",
          "tenderDocumentIssued",
          "siteSurveyQuestions",
          "tenderControlPrice",
          "judgesNumber",
          "tendererJudgesNumber",
          "socialJudgesNumber",
          "tendereringRemarks",
          "opentingSituation",
          "bidSituation",
          "publicitySuccessful",
          "bidWinNotice",
          "opentingRemarks"
        ];
        // 遍历
        for (var i in arrKey) {
          // 判断当前是否存在值
          if (this.tendererSituation[arrKey[i]]) {
            // 设置当前状态
            this.stepsList[this.stepsActive].isSave = true;
            // 跳出循环
            break;
          }
        }
        // 判断设置状态
        if (this.evaluationReportList && this.evaluationReportList.length > 0)
          this.stepsList[this.stepsActive].isSave = true;
      } else if (this.stepsActive === 3) {
        // 判断当前流程是否存在数据
        if (
          this.tenderFormObj.priList.length > 0 ||
          this.winningBidFormObj.priiList.length > 0 ||
          this.noticList.length > 0 ||
          this.proList.length > 0
        ) {
          // 设置当前状态
          this.stepsList[this.stepsActive].isSave = true;
        } else {
          // 设置当前状态
          this.stepsList[this.stepsActive].isSave = false;
        }
      } else if (this.stepsActive === 4) {
        // 判断当前流程是否存在数据
        if (this.tendererSituation.processDescription) {
          // 设置当前状态
          this.stepsList[this.stepsActive].isSave = true;
          if (this.recordList && this.recordList.length > 0)
            this.stepsList[this.stepsActive].isSave = true;
        } else {
          // 设置当前状态
          this.stepsList[this.stepsActive].isSave = false;
          if (this.recordList && this.recordList.length > 0)
            this.stepsList[this.stepsActive].isSave = false;
        }
      }
    },
    /**
     * 点击流程
     */
    fun_GetClickSteps(val, index) {
      // 不是详情时
      if (this.controllerFlag !== "details") {
        // 判断是否选择项目
        if (!this.tendererSituation.constructionNo) {
          // 错误提示
          this.$alert("请优先选择项目信息！", "warning");
          return false;
        }
        // 执行保存
        this.fun_TenderInsUpd("bc");
      }
      // 执行当前流程是否填写内容
      this.fun_GetStepsIsData();
      // 赋值下标
      this.stepsActive = index;
    },
    /**
     * 上一步
     */
    fun_GetLastStep() {
      // 不是详情时
      if (this.controllerFlag !== "details") {
        // 判断是否选择项目
        if (!this.tendererSituation.constructionNo) {
          // 错误提示
          this.$alert("请优先选择项目信息！", "warning");
          return false;
        }
        // 执行保存
        this.fun_TenderInsUpd("bc");
      }
      // 执行当前流程是否填写内容
      this.fun_GetStepsIsData();
      // 减1
      this.stepsActive--;
    },
    /**
     * 下一步
     */
    fun_GetNextStep() {
      // 不是详情时
      if (this.controllerFlag !== "details") {
        // 判断是否选择项目
        if (!this.tendererSituation.constructionNo) {
          // 错误提示
          this.$alert("请优先选择项目信息！", "warning");
          return false;
        }
        // 执行保存
        this.fun_TenderInsUpd("bc");
      }
      // 执行当前流程是否填写内容
      this.fun_GetStepsIsData();
      // 赋值下标
      this.stepsActive++;
    },
    /**
     * 资格预审成员列表
     * @author shuhua
     */
    fun_PrequalificationMemberList() {
      // 公告编号
      let id = this.tendererSituation.noticeId;
      // 不是新增
      if (this.controllerFlag !== "insert") {
        // 招标投标表主键
        id = this.id;
      }
      // 发起请求
      fun_PostAction("/tendererSituation/tenderJoinSituationList", {
        id: id,
        controllerFlg: this.controllerFlag
      }).then(res => {
        // 结构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 参加开标会投标单位名单
          this.formObj.tableData = data;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 公告选择
     * @author shuhua
     */
    fun_projectInfo() {
      // 打开弹窗
      this.$refs.tendererNoticeChoose.dialogVisible = true;
    },
    /**
     * 选择项目后
     */
    fun_SetProject(e) {
      // 项目名称
      this.tendererSituation.prjName = e.tenderPrjName;
      // 公告编号
      this.tendererSituation.noticeId = e.id;
      // 打开全局加载
      this.fun_Loading();
      // 发起请求
      fun_GetAction("/tendererSituation/detailProject", {
        noticeId: e.id
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断是否请求成功
        if (result) {
          // 招标投标
          this.tendererSituation = data.tendererSituation;
          // 评标概述
          this.evaluationReportList = data.evaluationReportList;
          // 参与开标会投标单位名单
          this.formObj.tableData = data.joinList;
          // 招标机构组成人员信息
          this.orgList = data.orgList;
          // 招标控制价信息
          this.tenderFormObj.priList = data.priList;
          // 中标信息
          this.winningBidFormObj.priiList = data.priiList;
          // 房屋建筑工程规模
          this.winningList = data.winningList;
          // 招标公告异常信息
          this.noticList = data.noticList;
          // 招标信息异常
          this.proList = data.proList;
          // 遍历
          this.proList.map(e => {
            // 标段名称
            e.section = "第" + e.section + "标段";
          });
          // 项目负责人解锁变更信息
          this.recordList = data.recordList;
          // 设置甲方确认
          this.fun_GetTenderSignature(data);
          // 执行判断是否填写数据
          this.fun_GetInitializeStepsIsData();
          // 关闭加载
          this.fullLoading.close();
        } else {
          // 关闭遮罩
          this.fullLoading.close();
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_TenderInsUpd(state) {
      // 状态
      this.tendererSituation.state = state;
      // 如果时提交
      if (state === "tj") {
        // 验证表单
        this.$refs.errorForm.validate(errorValid => {
          // 验证通过
          if (errorValid) {
            // 验证表单
            this.$refs.ruleForm.validate(valid => {
              // 验证通过
              if (valid) {
                // 开启弹窗
                this.$refs.caLock.dialogCalock = true;
                // 签名数据
                this.$refs.caLock.data =
                  this.tendererSituation.prjName +
                  this.tendererSituation.noticeId;
                // 状态
                this.$refs.caLock.state = state;
              } else {
                // 切换流程
                this.stepsActive = 1;
                // 错误提示
                this.$alert(
                  "输入内容存在错误，请根据提示完善内容！",
                  "warning"
                );
                // 验证不通过
                return false;
              }
            });
          } else {
            // 切换流程
            this.stepsActive = 0;
            // 错误提示
            this.$alert("输入内容存在错误，请根据提示完善内容！", "warning");
            // 验证不通过
            return false;
          }
        });
      } else {
        // 提交的方法
        this.fun_Submit(state);
      }
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.tendererSituation.lockNo = lockNo;
      // 赋值数字签名
      this.tendererSituation.digitalSignature = digitalSignature;
      // 不为空
      if (this.title != "" && this.title != null) {
        // 招标人提交
        this.fun_TenderStampSubmit();
      } else {
        // 提交的方法
        this.fun_Submit();
      }
    },
    /**
     * 提交的方法
     * @author shuhua
     */
    fun_Submit(state) {
      // 如果是保存
      if (state == "bc" && !this.tendererSituation.constructionNo) {
        // 错误提示
        this.$alert("请优先选择项目信息！", "warning");
        return false;
      }
      // 加载框
      this.fun_Loading();
      // 发起请求
      fun_PostAction(
        "/tendererSituation/saveOrUpdate",
        {
          tendererSituation: JSON.stringify(this.tendererSituation),
          joinList: JSON.stringify(this.formObj.tableData),
          priList: JSON.stringify(this.tenderFormObj.priList),
          priiList: JSON.stringify(this.winningBidFormObj.priiList),
          regulators: this.tendererSituation.regulators,
          controllerFlg: this.controllerFlag
        },
        0
      ).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 返回id
          this.id = data.id;
          // 关闭遮罩
          this.fullLoading.close();
          // 判断是保存
          if (state === "bc") {
            // 修改状态
            this.controllerFlag = "update";
            // 请求详情
            this.fun_Details();
            return;
          }
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.$router.back();
        } else {
          // 关闭遮罩
          this.fullLoading.close();
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 甲方确认
     */
    fun_GetTenderSignature(data) {
      // 赋值招标人意见
      this.tendererSituation.tenderOpinion = data.tenderOpinion;
      // 赋值招标人意见
      this.tenderSignedForm.tenderOpinion = data.tenderOpinion;
      // 赋值招标人签章确认编号
      this.tenderSignedForm.tenderSignedId = data.tenderSignedId;
      // 赋值招标人签章状态
      this.tenderSignedForm.tenderSignedState = data.tenderSignedState;
      // 赋值添加标记
      this.tenderSignedForm.isDeregulation = data.isDeregulation;
      // 赋值招标人盖章确认的招标监管部门
      this.tenderSignedForm.esRegulators = data.esRegulators;
      // 赋值招标人盖章确认的招标监管流程
      this.tenderSignedForm.esProcessType = data.esProcessType;
      // 赋值招标人盖章确认权限编号
      this.tenderSignedForm.esInvitationId = data.esInvitationId;
      // 赋值招标人盖章的数字签名
      this.tenderSignedForm.tenderStampData = data.tenderStampData;
      // 表名
      this.tenderSignedForm.table = data.tendererSituation.tableName;
      // 字段
      this.tenderSignedForm.key = data.tendererSituation.keyState;
      // 数据编号
      this.tenderSignedForm.recordNumber = data.tendererSituation.id;
    },
    /**
     * 甲方确认提交与退还
     */
    fun_TenderStamp(e) {
      // 如果招标人意见不为空
      if (
        this.tendererSituation.tenderOpinion != "" &&
        this.tendererSituation.tenderOpinion != null
      ) {
        // 设置招标人意见
        this.tenderSignedForm.tenderOpinion = this.tendererSituation.tenderOpinion;
      }
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data =
        this.tendererSituation.prjName + this.tendererSituation.noticeId;
      // 状态
      this.$refs.caLock.state = e;
      this.$refs.caLock.tenderSigned = e;
      this.$refs.caLock.tenderSignedForm = this.tenderSignedForm;
    },
    /**
     * 添加时执行的方法
     * @author shuhua
     */
    tableRowClassName(row, rowIndex) {
      // 给每一行新增一个下标
      row.row.index = row.rowIndex;
    },
    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index";
      }
    },
    /**
     * 悬浮显示
     */
    inputOnMouseOver(event) {
      const target = event.target;
      // 判断是否开启tooltip功能
      if (target.offsetWidth < target.scrollWidth) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 声明
          let objData = {
            id: Math.random()
              .toString(36)
              .substring(2, 15), // id
            name: null, // 姓名
            corpName: null, // 工作单位
            duty: null, // 职务
            section: null // 标段号
          };
          // 添加数据
          this.formObj.tableData.push(objData);
          break;
        case "修改":
          // 调用修改方法
          break;
        default:
          // 调用删除方法
          this.fun_Del();
      }
    },
    /**
     * 删除的方法
     * @author shuhua
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过一条
        if (this.multipleSelection.length > 1) {
          // 勾选多条时，提示
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 弹出询问confirm
          this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 获取id
            const id = fun_GetKeys(this.multipleSelection);
            // 过滤掉
            this.formObj.tableData = this.formObj.tableData.filter(
              item => item.id !== id
            );
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     * @author 滕威
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 打开弹窗
     */
    fun_GetDialog(title, val) {
      // 打开弹窗
      this.dialogVisible = true;
      // 设置弹框名称
      this.dialogTitle = title;
      // 设置弹框内容
      this.dialogCount = val;
      // 设置弹框操作状态
      this.dialogControllerFlag = "details";
    },
    /**
     * 打开弹窗
     */
    fun_GetDialogWrite(title, val) {
      // 打开弹窗
      this.dialogVisible = true;
      // 设置弹框名称
      this.dialogTitle = title;
      // 设置弹框主键
      this.dialogId = val.id;
      // 设置弹框操作状态
      this.dialogControllerFlag = "update";
      // 发起请求
      fun_PostAction("/tendererSituation/scopeQuery", {
        id: val.id
      }).then(res => {
        // 结构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 赋值招标投标情况表招标范围
          this.dialogCount = data.situationTenderScope;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 修改弹框
     */
    fun_UpdDialog() {
      // 发起请求
      fun_PostAction("/tendererSituation/updScopeQuery", {
        id: this.dialogId,
        situationTenderScope: this.dialogCount
      }).then(res => {
        // 结构res.data
        const { result, msg } = res.data;
        // 操作成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
          // 关闭弹窗
          this.dialogVisible = false;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    }
  }
};
